import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import Card from 'components/Card';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import TextArea from 'components/TextArea';
import S from '../styles.scss';

const HaltCard = ({
  newConstructionAnswered,
  handleHaltQuestion,
  haltNote,
  handleHaltNote,
  submitHaltNote,
}) => <Card>
  <div className={S.headerContainer}>
    <h4 className={S.title}>Potential Halt</h4>
  </div>
  <div className={S.checklistContainer}>
    <p>
      Have you had any construction done or made any changes to the areas
      where the flooring will be installed since the last time we visited your home?
    </p>
    <br />
    <Button
      label="YES"
      flat inverse ripple
      disabled={newConstructionAnswered === 'yes'}
      className={S.standardButton}
      onClick={() => handleHaltQuestion('newConstructionAnswered', 'yes')}
    />
    <Button
      label="NO"
      flat inverse ripple
      disabled={newConstructionAnswered === 'no'}
      className={S.standardButton}
      onClick={() => handleHaltQuestion('newConstructionAnswered', 'no')}
    />
    <br />
    <br />
    {newConstructionAnswered === 'yes' && <ContainerDiv>
      <DropdownDiv condition={newConstructionAnswered === 'yes'}>
        <p>
          When changes are made to the installation areas it can affect the amount of
          materials needed for your installation. We will need to come out and perform a
          remeasure at your home before we can proceed with the installation. I am going
          to put in the request and you will receive a call back to schedule.
        </p>
        <br />
        <TextArea
          label="Notes"
          value={haltNote}
          onChange={handleHaltNote}
        />
        <br />
        <Button
          label="End Call"
          flat inverse ripple
          className={S.saveButton}
          disabled={!haltNote}
          onClick={submitHaltNote}
        />
      </DropdownDiv>
    </ContainerDiv>}
  </div>
</Card>;

HaltCard.propTypes = {
  newConstructionAnswered: PropTypes.string,
  handleHaltQuestion: PropTypes.func,
  haltNote: PropTypes.string,
  handleHaltNote: PropTypes.func,
  submitHaltNote: PropTypes.func,
};

export default HaltCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/haltCard.jsx